import React, { useEffect, useState } from "react"
import { Card, Col, PopoverBody, Row, UncontrolledPopover } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import action from "../../../assets/icons/action.svg"
// import EditSeries from "./edit"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import {
  fetchFinanceCategory,
  fetchFinanceCostCenter,
  updateCatStatus,
} from "../../../services/finance/finance"
import FinanceFilter from "../filter"
import NumberFormat from "../../../utils/numberFormat"

const FinanceCostCenter = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Category${companyname ? ` | ${companyname}` : ''}`;
  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const [page, setPage] = useState("")
  const desimalrange = localStorage.getItem("desimalrange")

  const [series, setSeries] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [ccFil, setCCFil] = useState("")
  const [count, setCount] = useState(0)
  //   const [editSeries, setEditSeries] = useState({ modal: false, value: "" })

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchFinanceCostCenter({
        params: `${ccFil ? `&code=${ccFil}` : ""}${
          search ? `&searchText=${search}` : "&searchText"
        }${page ? `&page=${page}` : ""}${`&sizePerPage=16`}`,
      })
      setSeries(response)
    }
    fetchData()
  }, [count, ccFil, search, page])

  //   const handleEdit = item => {
  //     setEditSeries({ value: item, modal: true })
  //   }

  const handleStatus = async id => {
    try {
      const response = await updateCatStatus(id)
      toastSuccess(response?.message)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const columns = [
    {
      label: "CC Code",
      renderCell: item => item?.description,
    },
    {
      label: <div className="text-end pe-5">Amount</div>,
      renderCell: item => <div className="text-end pe-5">{NumberFormat(Number(item?.amount ? item?.amount : "-"), desimalrange, desimalrange)}</div>,
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleUpdate = () => {
    setCount(count + 1)
  }

  //   const handleResetValue = () => {
  //     setEditSeries("")
  //   }

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleCCChange = data => {
    setCCFil(data)
    setPage(1)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Finance"
              breadcrumbObject={[
                { title: "Finance", link: "/finance" },
                { title: "Category", link: "/finance-category" },
              ]}
            />
            {/* {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "financecategory_create"
            ) && (
              <EditSeries
                key={"x"}
                onUpdate={handleUpdate}
                onReset={handleResetValue}
                buttonLabel="+&nbsp; Category"
                className="px-2 mb-3 btn btn-primary"
                editItem={editSeries}
              />
            )} */}
          </div>
          <Card className="me-2 px-2 pb-2">
            <FinanceFilter
              handleSearchChange={handleSearchChange}
              handleCCChange={handleCCChange}
              sampleUrl={"download/series.xlsx"}
              importUrl={"finance-cat/import"}
              showExport={
                loggedUser?.permission?.some(
                  permissionItem =>
                    permissionItem?.name === "financecategory_create"
                )
                  ? true
                  : false
              }
              isCC={true}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                {series?.data?.data && (
                  <UpdateTable
                    className="mt-5"
                    nodes={series?.data?.data}
                    paginate={series?.data}
                    CurrentPage={page}
                    columns={columns}
                    handlePagination={handlePaginate}
                    tableWidth="50% 50%"
                    mobileWidth="70% 40%"
                  />
                )}
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default FinanceCostCenter
